import { FC, useCallback, useEffect, useRef, useState } from 'react';

import { EvSegmentedButtons } from '@evinced-private/ui-common';

import { getFromLocalStorage, saveToLocalStorage } from 'src/api/LocalStorageApi';

import { THEME_OPTIONS, THEME_STORAGE_KEY, THEME_TRANSITION_DURATION_MS } from './consts';

import './ThemeToggle.scss';

export const ThemeToggle: FC = () => {
	const [theme, setTheme] = useState<string>(() => {
		return getFromLocalStorage(THEME_STORAGE_KEY) || 'light';
	});
	const transitionTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	useEffect(() => {
		document.documentElement.setAttribute('data-color-theme', theme);
	}, [theme]);

	useEffect(() => {
		return () => {
			if (transitionTimeoutRef.current !== null) {
				clearTimeout(transitionTimeoutRef.current);
			}
		};
	}, []);

	const onPress = useCallback((pressedButtons: string[]) => {
		const selectedTheme = pressedButtons[0];

		if (transitionTimeoutRef.current !== null) {
			clearTimeout(transitionTimeoutRef.current);
			transitionTimeoutRef.current = null;
		}

		document.documentElement.classList.add('theme-transition');
		setTheme(selectedTheme);
		saveToLocalStorage(THEME_STORAGE_KEY, selectedTheme);

		transitionTimeoutRef.current = setTimeout(() => {
			transitionTimeoutRef.current = null;
			document.documentElement.classList.remove('theme-transition');
		}, THEME_TRANSITION_DURATION_MS);
	}, []);

	return (
		<EvSegmentedButtons
			options={THEME_OPTIONS}
			onPress={onPress}
			isControlled
			value={[theme]}
			ariaLabel="Color theme"
		/>
	);
};
